<template>
  <div class="home-user-planning">
    <div class="d-flex align-center ml-2 mb-2">
      <span class="text-h6">{{ $t('HOME.MY_BUBBLES_NEWS') }}</span>
      <v-tooltip max-width="250" content-class="line-height-normal">
        <template #activator="{ props }">
          <v-icon color="info" size="small" class="ml-2" v-bind="props">far fa-question-circle</v-icon>
        </template>
        <span>{{ $t('HOME.BUBBLES_EXPLANATIONS') }}</span>
      </v-tooltip>
    </div>
    <div>
      <v-card v-if="! loaded" class="flex-center-center" style="font-size:18px; height: 240px"><i class="far fa-spinner fa-spin fa-2x fa-fw"></i></v-card>
      <v-card v-else-if="! elements.length" class="pa-4 d-flex gap-4 align-center text-medium-emphasis">
        <!-- empty state -->
        <img src="@/img/view_bg.svg" style="height: 180px; max-width: 50%; filter: grayscale(1)">
        <div style="max-width: 380px">
          <div class="mb-2 font-weight-black">{{ $t('HOME.NO_ACTIVITY') }}</div>
          <div>{{ $t('HOME.FIND_HERE') }} {{ $t('HOME.BUBBLES_EXPLANATIONS').charAt(0).toLowerCase() }}{{ $t('HOME.BUBBLES_EXPLANATIONS').slice(1) }}</div>
        </div>
      </v-card>
      <v-card v-else>
        <div v-if="planning?.elements?.length">
          <div id="viewer" style="background: transparent;">
            <planning-content :planning="planning" view></planning-content>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<style lang="scss">
  .home-user-planning {
    .content {
      margin-right: 0 !important;
    }

    #table-header.fixed, #kanban-col-headers.fixed {
      // a better solution would be to remove the fixed class when planning is not on viewport
      position: static !important;
      box-shadow: none !important;
    }
    .table-header-placeholder {
      display: none !important;
    }
  }
</style>

<script>
  import { mapState } from 'pinia';
  import useHomeUserStore from '@/stores/home-user';
  import usePlanningStore from '@/stores/planning/planning';
  import Planning from '@/models/Planning';
  import PlanningContent from '@/components/Planning/PlanningContent.vue';

  export default {
    components: {
      PlanningContent,
    },
    data() {
      return {
        planning: null,
        planningStore: usePlanningStore(),
      };
    },
    computed: {
      ...mapState(useHomeUserStore, ['elements', 'loaded']),
    },
    watch: {
      loaded(newVal) {
        if (newVal) this.computeProject();
      },
    },
    methods: {
      computeProject() {
        const elements = [];
        const lanesByProjectId = {};
        this.elements.forEach((element) => {
          const planning = element.getPlanning();
          if (! lanesByProjectId[planning.id]) {
            lanesByProjectId[planning.id] = { id: planning.id, label: planning.getTitle(), url: planning.meta.url };
          }
          const newEl = angular.copy(element);
          newEl.setLaneId(planning.id);
          newEl.setDependencies(null);
          newEl.setTimeBar(null);
          newEl.setConfig({ 'show-progress': true, 'show-step': true });
          elements.push(newEl);
        });

        this.planning = new Planning({
          timeline: { steps: ['weeks', 'days'], hidden: { before: moment().add(-2, 'days').startOf('day'), after: moment().add(6, 'days').endOf('day') }, colwidth: 100 },
          lanes: Object.values(lanesByProjectId),
          elements,
        });
        this.planningStore.set({ planning: this.planning });
      },
    },
  };
</script>
